module.exports = __webpack_public_path__ + "img/edge_hiver_luge.3990c452.svg";